import { MeetingContext } from '@/meeting/contexts/MeetingContext'
import NextStepItem from '@/nextStep/components/NextStepItem'
import NextStepModal from '@/nextStep/modals/NextStepModal'
import { Alert, AlertIcon, Text, useDisclosure } from '@chakra-ui/react'
import { ThreadActivityNextStepFragment } from '@rolebase/shared/model/thread_activity'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import ThreadActivityLayout from './ThreadActivityLayout'

interface Props {
  activity: ThreadActivityNextStepFragment
}

export default function ThreadActivityNextStep({ activity }: Props) {
  const { t } = useTranslation()
  // Correcting is offered where writing is: inside a running meeting (G2-D4).
  // Read again later, the card is a record — and a record does not get edited.
  const meetingState = useContext(MeetingContext)
  const meetingCircle = meetingState?.isEnded ? undefined : meetingState?.circle
  const editModal = useDisclosure()

  return (
    <ThreadActivityLayout activity={activity} allowDelete>
      <Text color="gray.500" _dark={{ color: 'gray.300' }}>
        {t(`ThreadActivityNextStep.text`)}
      </Text>
      {activity.refNextStep ? (
        // No checkbox on purpose (G2-D8): the thread tells what was decided,
        // the meeting board and the personal page are where a step gets ticked.
        <NextStepItem
          nextStep={activity.refNextStep}
          onEdit={meetingCircle ? editModal.onOpen : undefined}
          maxW="2xl"
        />
      ) : (
        <Alert status="warning">
          <AlertIcon />
          {t('ThreadActivityNextStep.notAllowed')}
        </Alert>
      )}

      {editModal.isOpen && meetingCircle && activity.refNextStep && (
        <NextStepModal
          scopeCircleId={meetingCircle.id}
          nextStep={activity.refNextStep}
          isOpen
          onClose={editModal.onClose}
        />
      )}
    </ThreadActivityLayout>
  )
}
